import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
declare var hbspt: any;

@Component({
  selector: 'app-iframe',
  templateUrl: './iframe.component.html',
  styleUrls: ['./iframe.component.scss']
})
export class IframeComponent {

  safeUrl: SafeResourceUrl;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer
  ) {
    /*this.safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(data.url);
    hbspt.forms.create({
      region: "na1",
      portalId: "23647426",
      formId: "d745d73e-7630-47a2-95cf-d0c3e6f46132",
      target: '#hubspot-form-modal'
    });*/
  }

}